// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"2470291d","533":"93dc2f5e"}[chunkId] + ".chunk.js";
};